/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Info_Legal_KvkInputs */

const en_footer_info_legal_kvk = /** @type {(inputs: Footer_Info_Legal_KvkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(kvk 92951031)`)
};

/**
* | output |
* | --- |
* | "(kvk 92951031)" |
*
* @param {Footer_Info_Legal_KvkInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_info_legal_kvk = /** @type {((inputs?: Footer_Info_Legal_KvkInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Info_Legal_KvkInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_info_legal_kvk(inputs)
});